const hasText = value => typeof value === 'string' && value.trim().length > 0;

export const isPlayableChatPreview = preview =>
    hasText(preview?.id) && hasText(preview.fullTrackId) && hasText(preview.mp3URL);

export const playableChatPreviews = (previews) => {
    const ids = new Set();
    return previews.filter(preview => {
        if (!isPlayableChatPreview(preview) || ids.has(preview.id)) return false;
        ids.add(preview.id);
        return true;
    });
};

export const chatResponsePreviews = (sections) => playableChatPreviews(
    sections.flatMap(section => (Array.isArray(section?.components) ? section.components : [])
        .filter(component => component?.type === 'preview')
        .map(component => component.payload)),
);
